<template>
  <main>
    <div class="d-flex flex-column mx-auto pa-5" style="max-width: 500px;">
      <div class="mx-auto mb-6">
        <v-img max-width="150px" src="../../assets/images/logos/logo.png"></v-img>
      </div>

      <p class="text-center font-weight-medium">Selamat Datang di Sistem Informasi Orang Tua/Wali</p>

      <v-card>
        <v-card-text>
          <p class="font-weight-bold mb-2">Login</p>
          <p class="text-caption">
            Isikan Nomor Induk Mahasiswa (NIM) dan password untuk masuk dan melihat informasi kegiatan perkuliahan
          </p>

          <form @submit.prevent="loginMember">
            <v-text-field 
              label="Nomor Induk Mahasiswa (NIM)" 
              v-model="login.username">
            </v-text-field>
            <v-text-field 
              label="Password" 
              v-model="login.password" 
              :type="isPasswordVisible ? 'text' : 'password'" 
              :append-icon="isPasswordVisible ? icons.mdiEyeOutline : icons.mdiEyeOffOutline" 
              @click:append="isPasswordVisible = !isPasswordVisible">
            </v-text-field>

            <div class="mt-4">
              <v-btn type="submit" block color="primary" :disabled="isSubmitting">
                {{ isSubmitting ? 'Sedang melakukan proses ...' : 'Masuk Sekarang' }}
              </v-btn>
            </div>
          </form>
        </v-card-text>
      </v-card>
    </div>
  </main>

</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'

export default {
  data() {
    return {
      login: {
        username: '',
        password: '',
      },
      isPasswordVisible: false,
      isSubmitting: false,
      errors: [],
      
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline
      },
    }
  },
  mounted() {
    this.$isLoading(true)
    // this.imageBanner()
    setTimeout(() => {
      this.$isLoading(false)
    }, 2000)
  },
  methods: {
    async loginMember(e) {
      this.$isLoading(true)
      this.isSubmitting = true

      if (this.$data.login.username.length === 0) {
        this.errors.push('Username wajib diisi !')
        this.$swal.fire({
          title: 'Error',
          text: 'Username wajib diisi !',
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000,
        })

        this.$isLoading(false)
        this.isSubmitting = false
      } else if (this.$data.login.password.length === 0) {
        this.errors.push('Password wajib diisi !')
        this.$swal.fire({
          title: 'Error',
          text: 'Password wajib diisi !',
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000,
        })

        this.$isLoading(false)
        this.isSubmitting = false
      } else {
        this.axios
            .post(`${process.env.VUE_APP_ROOT_API}/api/ortu/auth/login`, this.login, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-type': 'application/json',
              }
            })
            .catch(err => {
              this.$swal.fire({
                title: 'Error',
                html: err.response.data.message,
                icon: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 3000,
              })

              localStorage.removeItem('token') //clear token atau key

              this.isSubmitting = false
            })
            .then(response => {
              this.$isLoading(false)
              this.messages = response.data.message
              this.auth = response.data.role_id
              this.tokens = response.data.token

              if (this.auth == process.env.VUE_APP_ROLE_ORANGTUA) {
                localStorage.setItem('token', response.data.token)
                this.$router.push('/orangTua/dashboard')

                this.isSubmitting = false
              } else {
                this.$swal.fire({
                  title: 'Error',
                  html: "Maaf halaman ini tidak bisa dibuka !",
                  icon: 'error',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 3000,
                })

                localStorage.removeItem('token') //clear token atau key
                this.isSubmitting = false
              }
            })
        
        this.$isLoading(false)

        return true
      }
      
      e.preventDefault()
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';

.box {
  
  border-radius: 4px;
  padding: 20px;
  align-self:center;
  width: 100%;
  text-align: center;
  
}

.box h3 {
  margin-top: 0;
}
</style>

